module.exports = __webpack_public_path__ + "static/media/cdp-icon.f8d906b6.png";